interface ColorPickerFieldProps {
  label: string;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  id?: string;
}

/** Java ARGB signed int → #RRGGBB hex string */
function javaColorToHex(colorCode: number): string {
  const rgb = colorCode & 0x00FFFFFF;
  return '#' + rgb.toString(16).padStart(6, '0');
}

/** #RRGGBB hex string → Java ARGB signed int (with 0xFF alpha) */
function hexToJavaColor(hex: string): number {
  const rgb = parseInt(hex.slice(1), 16);
  const argb = (0xFF000000 | rgb) >>> 0;
  return argb > 0x7FFFFFFF ? argb - 0x100000000 : argb;
}

export function ColorPickerField({ label, value, onChange, id }: ColorPickerFieldProps) {
  const hexValue = value != null ? javaColorToHex(value) : '#000000';

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <div className="flex items-center gap-2">
        <input
          type="color"
          id={id}
          value={hexValue}
          onChange={(e) => onChange(hexToJavaColor(e.target.value))}
          className="h-9 w-14 cursor-pointer rounded border border-gray-300 p-0.5"
        />
        <span className="text-sm text-gray-500 font-mono">{value != null ? hexValue : 'none'}</span>
        {value != null && (
          <button
            type="button"
            onClick={() => onChange(undefined)}
            className="text-xs text-gray-400 hover:text-gray-600 underline"
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
}
